// extracted by mini-css-extract-plugin
module.exports = {"characters":"Characters_characters__OdVjM","noResults":"Characters_noResults__cWAIj"};